<template>
    <div :class="[cssClass]" v-if="displayItems.length">
        <div class="h6 title-history">{{ $t('views.company_register.history_title') }}</div>
        <ul>
            <li v-for="(item, index) in displayItems" :key="index" @click="selectItem(item)">
                <div class="left">
                    <CompanyLogo
                        :domain="item.domain ? item.domain : null"
                        :company_name="item.name ? item.name : item.domain ? item.domain : null"
                    />
                </div>
                <div class="right">
                    <div class="name h2">{{ item.name }}</div>
                    <div class="timestamp">{{ timestampToDisplayDate(item.timestamp / 1000) }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import CompanyLogo from '@/components/misc/CompanyLogo';
    import { useSearchHistoryStore } from '@/stores/searchHistory';
    import { timestampToDisplayDate } from '@/utils/dates';

    export default {
        name: "SearchHistory",
        components: {
            CompanyLogo
        },
        props: {
            cssClass: {
                type: String,
                default: 'search-history-1'
            },
            maxItems: {
                type: Number,
                default: 1000
            }
        },
        emits: ['select'],
        computed: {
            ...mapState(useSearchHistoryStore, ['history']),
            displayItems() {
                return this.history?.length ? this.history
                    .filter(item => item.timestamp)
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                    .slice(0, this.maxItems) : [];
            },
        },
        methods: {
            timestampToDisplayDate,
            selectItem(item) {
                if (item.id) {
                    this.$emit('select', item);
                }
            },
        }
    }
</script>